/**
 * New flow defaults
 */
import {ChannelConfig} from '../../../../../../../shared/models';
import isEmpty from 'lodash/isEmpty';

export interface DisplayTypeChannel {
    channelId: number;
    channelName: string;
}

export interface DisplayTypeModalData {
    isDirty: boolean;
    displayType: {};
    customListButton: string;
}

export const displayTypeChannels = [6, 7, 8, 11, 13];

export const CUSTOM_OPTIONS = {
    8 : ['LIST'],
};

export const CHANNEL_DEFAULTS = {
    6: 'NUMBER',
    7: 'NUMBER',
    8: 'AUTO',
    11: 'AUTO',
    13: 'AUTO'
};

/**
 * Existing flow defaults
 */
export const CHANNEL_DEFAULT_FALLBACK = {
    8: 'NUMBER',
    13: 'LIST'
};

export const displayTypeOptionsPerChannel = {
    6: [{type: 'NUMBER', description: '1+ | E.G. BANK SERVICE MENU'}],
    7: [{type: 'NUMBER', description: '1+ | E.G. BANK SERVICE MENU'}],
    8: [
        {type: 'AUTO', description: ''},
        {type: 'BUTTON', description: '1 – 3 options | E.G. Choosing payment method'},
        {type: 'LIST', description: '1 – 10 options | E.G. BANK SERVICE MENU'},
        {type: 'NUMBER', description: '1+ | E.G. BANK SERVICE MENU'}
    ],
    11: [
        {type: 'AUTO', description: ''},
        {type: 'BUTTON', description: '1 – 5 options | E.G. Choosing payment method'},
        {type: 'LIST', description: '1 – 10 options | E.G. BANK SERVICE MENU'},
        {type: 'NUMBER', description: '1+ | E.G. BANK SERVICE MENU'}
    ],
    13: [
        {type: 'AUTO', description: ''},
        {type: 'BUTTON', description: '2 - 5 options | E.G. Choosing payment method'},
        {type: 'LIST', description: '1+ options | E.G. BANK SERVICE MENU'}
    ]
};

export const DISPLAY_TYPE_INDEX_LIMIT = {
    6: { 'NUMBER' : {max: 0, range: '1+', name: 'Numbered List'}},
    7: { 'NUMBER' : {max: 0, range: '1+', name: 'Numbered List'}},
    8: {
        'AUTO' : {max: 0, range: '1+', name: 'Auto Select' },
        'BUTTON': {max: 3, range: '1 - 3', name: 'Reply Buttons'},
        'LIST': {max: 10, range: '1 - 10', name: 'List Messages'},
        'NUMBER': {max: 0, range: '1+', name: 'Numbered List'}
    },
    11: {
        'AUTO' : {max: 0, range: '1+', name: 'Auto Select' },
        'BUTTON': {max: 5, range: '1 - 5', name: 'Reply Buttons'},
        'LIST': {max: 10, range: '1 - 10', name: 'List Messages'},
        'NUMBER': {max: 0, range: '1+', name: 'Numbered List'}
    },
    13: {
        'AUTO': {max: 0, range: '1+', name: 'Auto Select'},
        'BUTTON': {max: 5, range: '2 - 5', name: 'Quick Replies'},
        'LIST': {max: 0, range: '1+', name: 'List Picker'}
    }
};

export const DISPLAY_TYPE_CHANNELS = {
    6: 'SMS',
    7: 'USSD',
    8: 'WhatsApp',
    11: 'Web Chat',
    13: 'ABC'
};

export const DISPLAY_TYPE_CHANNEL_CONFIG = {
    6: { name: 'SMS' },
    7: { name: 'USSD' },
    8: { name: 'WhatsApp' },
    11: { name: 'Web Chat' },
    13: { name: 'Apple Business Chat' }
};

export const DISPLAY_TYPE_CHANNELS_KEYS = {
    sms: '6',
    ussd: '7',
    whatsApp: '8',
    wbc: '11',
    abc: '13'
};

export const SELECTED_DISPLAY_TYPE_TEXT = {
    default: '(Default)',
    custom: '(Custom)'
};

/**
 *
 * @param dataType The current displayType config -> 'number' || {8, 'NUMBER', 13: 'LIST'}
 * @param channelId A channelId that is configured for this client
 * @public Determines whether the node belongs to a new or existing flow then sets a channels displayType
 * @return The channels displayType eg. 'number'
 */
export const getFormData = (dataType: any, channelId: number): string => {
    // Accommodates the legacy display type structure
    if (typeof dataType === 'string' && CHANNEL_DEFAULT_FALLBACK[channelId]) {
        // existing flow with channel 8 or 13
        return CHANNEL_DEFAULT_FALLBACK[channelId];
    }
    if (typeof dataType === 'string') {
        // existing flow with channel 6, 7, 8 or 13
        return CHANNEL_DEFAULTS[channelId];
    }
    if (Object.keys(dataType).length === 0) {
        // new flow with channel 6, 7, 8 or 13
        return CHANNEL_DEFAULTS[channelId];
    }
    //  existing flow with new displayType structure
    return dataType[channelId] ? dataType[channelId] : CHANNEL_DEFAULTS[channelId];
};

export const getSupportedDisplayChannels = (channels: ChannelConfig[]): DisplayTypeChannel[] => {
    return channels.filter(channel => DISPLAY_TYPE_CHANNELS.hasOwnProperty(channel['channel-id']))
        .map(channel => {
            const channelId = channel['channel-id'];
            return {
                channelId,
                channelName: DISPLAY_TYPE_CHANNEL_CONFIG[channelId].name
            };
        });
};

export const supportedDisplayChannels_fallback = (displayType: {}): DisplayTypeChannel[] => {

    let channelIds = Object.keys(DISPLAY_TYPE_CHANNEL_CONFIG);

    if (!isEmpty(displayType)) {
        channelIds = Object.keys(displayType);
    }

    return channelIds.map(channelId => {
        return {
            channelId,
            channelName: DISPLAY_TYPE_CHANNEL_CONFIG[channelId].name
        };
    }).reduce( (accumulator, currentValue) => accumulator.concat(currentValue), []);
};


